import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * CardBannerCTA component.
 * Renders a section with a title, description, and CTA buttons.
 * @param {Object} data - The data for the component.
 */
const CardBannerCTA = ({ data }) => {
    const { cardItem, additionalConfiguration, backgroundColor, customId } = data ?? {};
    const { title, cta, description } = cardItem ?? {};
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "py-25 px-3.75");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section
            className={`promoCardNoImage px-3.75 ${sectionPaddingClassName} ${sectionColorMapping?.bgColor}`}
            id={customId}
        >
            <div className="container">
                <div className={`grid ${styles.contentWrapper} gap-y-7.5 lg:gap-x-25`}>
                    <div>
                        {title && (
                            <h2
                                className={`leading-tight ${sectionColorMapping?.primaryTextColor}`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                        )}
                        {description?.description && (
                            <p className={`body-big mt-5  ${sectionColorMapping?.secondaryTextColor} `}>
                                {description?.description}
                            </p>
                        )}
                    </div>
                    <div className="flex items-center">
                        <div className="flex flex-wrap justify-center gap-3.75 md:gap-7.5">
                            {cta?.map((button) => (
                                <Cta key={button.id} data={button} className="py-2.5 lg:py-3.75" />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CardBannerCTA;
